import { useState } from 'react'
import { useAppSelector } from '../../hooks/redux'
import style from './GoButton.module.css'
import { Colors } from '../../constants/Colors'

interface Props {
    title: string,
    type: "submit" | "reset",
    disabled: boolean,
    left: boolean,
    right: boolean,
}

const GoButton = ({title, type, disabled, left, right}: Props) => {
    
    const theme = useAppSelector<string>(state => state.theme.theme)

    const [isHover, setIsHover] = useState<boolean>(false)

    const handleMouseEnter = () => {
        setIsHover(true)
    }

    const handleMouseLeave = () => {
        setIsHover(false)
    }

    return (
        <button
            className={style.goButton}
            style={
                disabled
                    ? {
                        color: Colors[theme ?? 'light'].activeTint,
                        backgroundColor: Colors[theme ?? 'light'].disabled
                    }
                    : isHover
                        ? {
                            border: `1px solid ${Colors[theme ?? 'light'].app}`,
                            color: Colors[theme ?? 'light'].app,
                            backgroundColor: Colors[theme ?? 'light'].white
                        }
                        : {
                            color: Colors[theme ?? 'light'].activeTint,
                            backgroundColor: Colors[theme ?? 'light'].app
                        }
            }
            type={type}
            disabled={disabled}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <span className={style.icon}>
                {left
                    ? <i className="fas fa-chevron-left"></i>
                    : null
                }
            </span>
            <span className={style.title}>
                {title
                    ? title
                    : null
                }
            </span>
            <span className={style.icon}>
                {right
                    ? <i className="fas fa-chevron-right"></i>
                    : null
                }
            </span>
        </button>
    )
}

export default GoButton